import { Api as api } from "../../api";
const prefix = '/master-data'
// const prefix = ''

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    cityServiceV1GetCityDropdown: build.query<
      CityServiceV1GetCityDropdownApiResponse,
      CityServiceV1GetCityDropdownApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/cities/dropdown`,
        params: {
          search: queryArg.search,
          page: queryArg.page,
          state_id: queryArg.stateId,
          country_id: queryArg.countryId,
        },
      }),
    }),
    cityServiceV1GetCity: build.query<
      CityServiceV1GetCityApiResponse,
      CityServiceV1GetCityApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/cities/${queryArg.id}` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as citiesApi };
export type CityServiceV1GetCityDropdownApiResponse =
  /** status 200 A successful response. */ CityV1GetCityDropdownRes;
export type CityServiceV1GetCityDropdownApiArg = {
  search?: string;
  page?: number;
  stateId?: string;
  countryId?: string;
};
export type CityServiceV1GetCityApiResponse =
  /** status 200 A successful response. */ CityV1CityDetailRes;
export type CityServiceV1GetCityApiArg = {
  id: string;
};
export type CityV1CityDropdownItemRes = {
  id?: string;
  name?: string;
  state_name?: string;
  country_name?: string;
};
export type CityV1CityDropdownPaginationMeta = {
  current_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
  limit?: number;
  total?: number;
  total_page?: number;
};
export type CityV1GetCityDropdownRes = {
  cities?: CityV1CityDropdownItemRes[];
  metadata?: CityV1CityDropdownPaginationMeta;
};
export type ProtobufAny = {
  /** Identifies the type of the serialized Protobuf message with a URI reference
    consisting of a prefix ending in a slash and the fully-qualified type name.
    
    Example: type.googleapis.com/google.protobuf.StringValue
    
    This string must contain at least one `/` character, and the content after
    the last `/` must be the fully-qualified name of the type in canonical
    form, without a leading dot. Do not write a scheme on these URI references
    so that clients do not attempt to contact them.
    
    The prefix is arbitrary and Protobuf implementations are expected to
    simply strip off everything up to and including the last `/` to identify
    the type. `type.googleapis.com/` is a common default prefix that some
    legacy implementations require. This prefix does not indicate the origin of
    the type, and URIs containing it are not expected to respond to any
    requests.
    
    All type URL strings must be legal URI references with the additional
    restriction (for the text format) that the content of the reference
    must consist only of alphanumeric characters, percent-encoded escapes, and
    characters in the following set (not including the outer backticks):
    `/-.~_!$&()*+,;=`. Despite our allowing percent encodings, implementations
    should not unescape them to prevent confusion with existing parsers. For
    example, `type.googleapis.com%2FFoo` should be rejected.
    
    In the original design of `Any`, the possibility of launching a type
    resolution service at these type URLs was considered but Protobuf never
    implemented one and considers contacting these URLs to be problematic and
    a potential security issue. Do not attempt to contact type URLs. */
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type CityV1CityDetailRes = {
  id?: string;
  name?: string;
  state_id?: string;
  state_code?: string;
  country_id?: string;
  country_code?: string;
  type?: string;
  level?: number;
  parent_id?: string;
  latitude?: number;
  longitude?: number;
  native?: string;
  population?: string;
  timezone?: string;
  state_name?: string;
  country_name?: string;
};
export const {
  useCityServiceV1GetCityDropdownQuery,
  useCityServiceV1GetCityQuery,
} = injectedRtkApi;